//It defines all the endpoints available to us for apis.
const API_ENDPOINTS_AVAILABLE = {
  VENDING_MANAGEMENT: "vending-management",
  USER_MANAGEMENT: "user-management",
};

//Every api has its own unique api key to fetch its url and action.
export const API_KEYS = {
  CHECK_AND_UPLOAD_CUSTOMER_DATA:Symbol.for("CHECK_AND_UPLOAD_CUSTOMER_DATA"),
  CREATE_USER_DETAILS: Symbol.for("CREATE_USER_DETAILS"),
  GET_VM_DETAILS: Symbol.for("GET_VM_DETAILS"),
  GET_VM_PRODUCTS: Symbol.for("GET_VM_PRODUCTS"),
  REQUEST_PRODUCT: Symbol.for("REQUEST_PRODUCT"),
  APPLY_COUPON: Symbol.for("APPLY_COUPON"),
  SEND_OTP: Symbol.for("SEND_OTP"),
  VERIFY_OTP: Symbol.for("VERIFY_OTP"),
  VALIDATE_CART_ITEMS: Symbol.for("VALIDATE_CART_ITEMS"),
  CREATE_CART: Symbol.for("CREATE_CART"),
  SYNC_CART: Symbol.for("SYNC_CART"),
  VALIDATE_DISPENSE: Symbol.for("VALIDATE_DISPENSE"),
  DISPENSE_LATER: Symbol.for(" DISPENSE_LATER"),
  GET_VENDING_STATUS_OF_PRODUCTS: Symbol.for("GET_VENDING_STATUS_OF_PRODUCTS"),
  ORDER_FEEDBACK: Symbol.for("ORDER_FEEDBACK"),
  CANCEL_ORDER: Symbol.for("CANCEL_ORDER"),
  CLIENT_DETAILS: Symbol.for("CLIENT_DETAILS"),
};

//Actions to be passed in api request body.
export const API_ACTIONS = {
  [API_KEYS.CANCEL_ORDER]: "cancel.order",
  [API_KEYS.DISPENSE_LATER]: "dispense.later",
  [API_KEYS.CREATE_USER_DETAILS]: "upload.customer_data",
  [API_KEYS.CHECK_AND_UPLOAD_CUSTOMER_DATA]:"checkAndUpload.customer_data",
  [API_KEYS.GET_VM_DETAILS]: "get.vm",
  // [API_KEYS.GET_VM_PRODUCTS]: "get.product.list",
    [API_KEYS.GET_VM_PRODUCTS]: "get.customer.product.list",
  [API_KEYS.REQUEST_PRODUCT]: "request.product",
  [API_KEYS.APPLY_COUPON]: "get.coupon.discount",
  [API_KEYS.SEND_OTP]: "send_otp",
  [API_KEYS.VERIFY_OTP]: "verify_otp",
  [API_KEYS.VALIDATE_CART_ITEMS]: "validate.cart.items",
  [API_KEYS.CREATE_CART]: "create.cart",
  [API_KEYS.SYNC_CART]: "sync.cart",
  [API_KEYS.VALIDATE_DISPENSE]: "validate.dispense",
  [API_KEYS.GET_VENDING_STATUS_OF_PRODUCTS]: "get.vending.status",
  [API_KEYS.ORDER_FEEDBACK]: "create.feedback",
  [API_KEYS.CLIENT_DETAILS]: "list.company_images_for_sample",
};

//Defines unique endpoint of each api using API_KEYS.
export const API_ENDPOINTS = {
  [API_KEYS.CANCEL_ORDER]: API_ENDPOINTS_AVAILABLE.VENDING_MANAGEMENT,
  [API_KEYS.DISPENSE_LATER]: API_ENDPOINTS_AVAILABLE.VENDING_MANAGEMENT,
  [API_KEYS.GET_VM_DETAILS]: API_ENDPOINTS_AVAILABLE.VENDING_MANAGEMENT,
  [API_KEYS.GET_VM_PRODUCTS]: API_ENDPOINTS_AVAILABLE.VENDING_MANAGEMENT,
  [API_KEYS.REQUEST_PRODUCT]: API_ENDPOINTS_AVAILABLE.VENDING_MANAGEMENT,
  [API_KEYS.APPLY_COUPON]: API_ENDPOINTS_AVAILABLE.VENDING_MANAGEMENT,
  [API_KEYS.USER_MANAGEMENT]: API_ENDPOINTS_AVAILABLE.USER_MANAGEMENT,
  [API_KEYS.SEND_OTP]: API_ENDPOINTS_AVAILABLE.USER_MANAGEMENT,
  [API_KEYS.VERIFY_OTP]: API_ENDPOINTS_AVAILABLE.USER_MANAGEMENT,
  [API_KEYS.CREATE_USER_DETAILS]: API_ENDPOINTS_AVAILABLE.USER_MANAGEMENT,
  [API_KEYS.CHECK_AND_UPLOAD_CUSTOMER_DATA]:API_ENDPOINTS_AVAILABLE.USER_MANAGEMENT,
  [API_KEYS.VALIDATE_CART_ITEMS]: API_ENDPOINTS_AVAILABLE.VENDING_MANAGEMENT,
  [API_KEYS.CREATE_CART]: API_ENDPOINTS_AVAILABLE.VENDING_MANAGEMENT,
  [API_KEYS.VALIDATE_DISPENSE]: API_ENDPOINTS_AVAILABLE.VENDING_MANAGEMENT,
  [API_KEYS.GET_VENDING_STATUS_OF_PRODUCTS]:
    API_ENDPOINTS_AVAILABLE.VENDING_MANAGEMENT,
  [API_KEYS.SYNC_CART]: API_ENDPOINTS_AVAILABLE.VENDING_MANAGEMENT,
  [API_KEYS.ORDER_FEEDBACK]: API_ENDPOINTS_AVAILABLE.VENDING_MANAGEMENT,
  [API_KEYS.CLIENT_DETAILS]: API_ENDPOINTS_AVAILABLE.VENDING_MANAGEMENT,
};
